import { Button, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { theme } from '../Mui/Theme';

interface NavButtonProps {
    to: string;
    text: string;
    onClick?: () => void;
    icon?: React.ReactNode;
}

export const NavButton: React.FC<NavButtonProps> = ({
    to,
    text,
    onClick,
    icon,
}) => {
    return (
        <NavLink to={to} onClick={onClick ? onClick : undefined}>
            <Button
                variant="contained"
                sx={{
                    margin: '10px',
                    width: '150px',
                    height: '70px',
                    borderRadius: '20px',
                    color: theme.palette.primary.light,
                    background: theme.palette.secondary.main,
                    '&:hover': {
                        backgroundColor: theme.palette.secondary.dark,
                        color: theme.palette.primary.main,
                    },
                }}
                startIcon={icon && icon}
            >
                <Typography
                    variant="button"
                    align="center"
                    sx={{
                        fontWeight: 'bold',
                    }}
                >
                    {text}
                </Typography>
            </Button>
        </NavLink>
    );
};
